type GameDefine = {};

export const tableGameDefine: GameDefine = {};
export default GameDefine;
